import { render, staticRenderFns } from "./edpBackendMenu.vue?vue&type=template&id=95821c10&"
import script from "./edpBackendMenu.vue?vue&type=script&lang=js&"
export * from "./edpBackendMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports